import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { generatePagesBar } from '../components/common/pagination'
import { formatDate } from '../components/common/dates'
import '../styles/BlogPage.css';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

const BlogPage = () => {
  console.log("Loaded BlogPage")
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page')) || 1;
  
  const [blogData, setBlogData] = useState(null);
  useEffect(() => {
      // Загрузка данных с бэкенда с параметром page
      fetch(`/api/blog/list?page=${currentPage}`)
      .then(res => res.json())
      .then(data => {
          setBlogData(data);
      })
      .catch(error => {
          console.error('Ошибка загрузки данных:', error);
          setBlogData({
          records: [],
          pages: { total: 1, current: currentPage }
          });
      });
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page === "...") return;
    setSearchParams({ page: page.toString() });
    window.scrollTo(0, 0);
  };

  if (!blogData) {
      return <div>Загрузка...</div>;
  }

  console.log(blogData)

  // const blogData = {
  //   records: [
  //     {
  //       title: "Тестовая запись",
  //       content: "sdfsdsdfsdfsdfsdfsdfsdf",
  //       published_at: 1756048427.646078
  //     },
  //     {
  //       title: "Тестовая запись",
  //       content: "sdfsdsdfsdfsdfsdfsdfsdf",
  //       published_at: 1756048427.646078
  //     },
  //     {
  //       title: "Тестовая запись",
  //       content: "sdfsdsdfsdfsdfsdfsdfsdf",
  //       published_at: 1756048427.646078
  //     },
      
  //   ],
  //   pages: {
  //     total: 4,
  //     current: 1
  //   }
  // }
  const pages = generatePagesBar(blogData.pages.total, blogData.pages.current)
  return (
    <div>
        <Header currentPage={"blog"} />
        <div className='content'>
          <div className="blog">
            <div className="title">МОЙ БЛОГ</div>
            {blogData.records.map((record, index) => (
              <React.Fragment key={record.id}>
                <div className="blogChapter">
                  <div className="title">{record.title}</div>
                  {record.content.split("\n").map((row, index) => (
                    <p key={index} className="blogContentItem">{row}</p>
                  ))}
                  <br />
                  <span className="blogTimestamp">{formatDate(record.published_at)}</span>
                
                </div>
                {index < blogData.records.length - 1 && <hr className="experienceDivider" />}
              </React.Fragment>
            ))}

          </div>
          <div className="pagination">
            {pages.map((page, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(page)}
                className={blogData.pages.current === page ? "paginationButtonActive" : page === "..." ? "ellipses" : "paginationButton"}
                disabled={page === "..."}
              >
                {page}
              </button>
            ))}
          </div>
          {/* <div className="blogChapterTelegramInvitation">
              <p className="blogTelegramInvitation">Хотите почитать расширенную версию блога - присоединяйтесь к каналу в <strong><a href="https://t.me/progers_note">Telegram. (18+)</a></strong></p>
              <p className="blogTelegramInvitation">Предупрежу лишь, что там цензура отсутствует, это мой островок выплеска эмоций в свободной форме, так что без обид ;)</p>
          </div> */}


        </div>
        <Footer />
    </div>
  );
};

export default BlogPage;